module.exports = __webpack_public_path__ + "74618057a71a18c65cd0b576b22e3e9a.png";